import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Spinner, classnames } from "@culturehq/components";
import { Trans } from "app/utils";

import styles from "./Success.module.scss";

type EventSuccessProps = {
  delayMs?: number;
  redirectTo?: string;
};

const EventSuccess: React.FC<EventSuccessProps> = ({ delayMs = 2000, redirectTo = undefined }) => {
  const [redirecting, setRedirecting] = useState<boolean>(false);

  useEffect(
    () => {
      if (redirectTo) {
        const timeout = setTimeout(() => setRedirecting(true), delayMs);

        return () => {
          clearTimeout(timeout);
        };
      }

      return undefined;
    },
    [delayMs, setRedirecting, redirectTo]
  );

  if (redirecting && redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <div className={styles["success-wrapper"]}>
      <div className={classnames(styles["success-sec"], "success-sec")}>
        <Spinner />
        <h1 className={styles["info-txt"]}>
          <Trans>Nice work!</Trans>
        </h1>
        <h4 className={styles["info-msg"]}>
          <Trans>Preparing your event for showtime <span role="img" aria-label="Event created successfully">🤩</span></Trans>
        </h4>
      </div>
    </div>
  );
};

export default EventSuccess;
